import React from "react";
import { useNavigate } from "react-router-dom";

export const UsersProductView = () => {
  const navigate = useNavigate();
  const items = new Array(5).fill(0).map((_,i)=>({
    id:i+1,
    name:"Banana cake",
    price:"₦12,000",
    img:[
      "https://images.unsplash.com/photo-1605470207062-1be28f5f2c65?w=200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1525351484163-7529414344d8?w=200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1514511542287-6c52c2f1f0f4?w=200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1526318472351-c75fcf070305?w=200&q=80&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1543353071-10c8ba85a904?w=200&q=80&auto=format&fit=crop",
    ][i]
  }));

  return (
    <div className="min-h-screen grid place-items-center bg-[#fff8e1]">
      <div className="relative app-container [font-family:'Nunito',Helvetica] text-[#5d4037] pb-40">
   
        <div className="w-full flex items-center mt-4">
          <button onClick={() => navigate(-1)} className="ml-4 w-9 h-9 rounded-full bg-[#ccb357] grid place-items-center" aria-label="Back">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>
          </button>
          <h1 className="flex-1 text-center font-bold text-[18px]">Food Products</h1>
          <div className="w-9" />
        </div>

      
        <div className="px-4 mt-4">
          <div className="relative">
            <input
              placeholder="Search Order"
              className="w-full h-[44px] pl-10 pr-4 rounded-full border border-[#5d4037] bg-[#fff8e1] outline-none"
            />
            <svg className="absolute left-3 top-1/2 -translate-y-1/2" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
          </div>
        </div>

    
        <div className="px-4 mt-4 space-y-3">
          {items.map((p)=>(
            <div key={p.id} className="rounded-[12px] bg-white border border-[#eadfb7] p-2 flex items-center">
              <button onClick={() => navigate("/products/details")} className="flex items-center flex-1 text-left">
                <img alt="" src={p.img} className="w-12 h-12 rounded-[8px] object-cover" />
                <div className="ml-3">
                  <p className="font-bold leading-5">{p.name}</p>
                  <p className="text-[12px]">{p.price}</p>
                </div>
              </button>

            </div>
          ))}
        </div>

      
        <div className="fixed bottom-3 md:bottom-6 left-1/2 -translate-x-1/2 w-full max-w-[1440px] xl:max-w-[1600px] px-6 md:px-10 xl:px-16">
          <div className="px-6 pt-2 pb-4 bg-white border-t border-[#eadfb7]">
            <div className="grid grid-cols-4 gap-4 text-[12px] text-[#5d4037]">
           
              <div className="flex flex-col items-center" onClick={()=>navigate('/dashboard')}>
                <div className="w-9 h-9 rounded-[12px] bg-white border border-[#eadfb7] grid place-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24"><path d="M3 10.5L12 4l9 6.5"/><path d="M5 10v10h14V10"/></svg>
                </div>
                <span className="mt-1 text-[#5d4037]/80">Overview</span>
              </div>
             
              <div className="flex flex-col items-center" onClick={()=>navigate('/orders')}>
                <div className="w-9 h-9 rounded-[12px] bg-white border border-[#eadfb7] grid place-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24"><rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 7h8M8 11h6M8 15h8"/></svg>
                </div>
                <span className="mt-1 text-[#5d4037]/80">Orders</span>
              </div>
             
              <div className="flex flex-col items-center" onClick={()=>navigate('/products/new')}>
                <div className="w-9 h-9 rounded-[12px] bg-white border border-[#eadfb7] grid place-items-center">
                  <div className="w-6 h-6 rounded-full border border-[#5d4037] grid place-items-center bg-[#f7c945]">
                    <span className="text-[11px] font-bold leading-none text-[#5d4037]">P</span>
                  </div>
                </div>
                <span className="mt-1 font-semibold">Products</span>
              </div>
          
              <div className="flex flex-col items-center" onClick={()=>navigate('/profile')}>
                <div className="w-9 h-9 rounded-[12px] bg-white border border-[#eadfb7] grid place-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5d4037" strokeWidth="2"><path d="M12 12a4 4 0 100-8 4 4 0 000 8z"/><path d="M20 21v-2a6 6 0 00-6-6H10a6 6 0 00-6 6v2"/></svg>
                </div>
                <span className="mt-1 text-[#5d4037]/80">Profile</span>
              </div>
            </div>
          </div>
          <div className="h-[22px] bg-[#5d4037] flex items-center justify-center">
            <div className="w-[120px] h-[6px] rounded-full bg-white"/>
          </div>
        </div>
      </div>
    </div>
  );
};
